import {
  PrimaryButton,
  SecondaryButton,
  SquareDotLoadingIndicator,
  Text,
  TextButton,
} from '@joor/design-system'
import styled from 'styled-components'

import messages from 'features/Orders/Review/review.messages'

const LoadingAddingProducts = () => (
  <LoaderWrapper>
    <SmallSquareLoader />
    <LoaderText
      fontSize="extrasmall"
      fontWeight="medium"
      letterSpacing="tight"
      lineHeight="12"
      color="primary-400"
    >
      {messages.loadingProducts}
    </LoaderText>
  </LoaderWrapper>
)

export const ProductsEditActions = ({
  loadingIframe,
  loadingSaveProducts,
  loadingSaveAndAddProducts,
  shouldShowReloadProducts,
  handleClickSave,
  handleCloseModal,
  handleReloadIframe,
}: ProductsEditActionsProps) => (
  <ModalButtonsContainer>
    {!loadingIframe &&
      !loadingSaveProducts &&
      (loadingSaveAndAddProducts ? (
        <LoadingAddingProducts />
      ) : (
        <ActionWrapper>
          <TextButton onClick={() => handleClickSave(true)}>
            {messages.saveAndAdd}
          </TextButton>
          {shouldShowReloadProducts && (
            <TextButton iconName="reset" onClick={handleReloadIframe}>
              {messages.reloadProducts}
            </TextButton>
          )}
        </ActionWrapper>
      ))}

    <SecondaryButtonWrapper onClick={handleCloseModal}>
      {messages.cancel}
    </SecondaryButtonWrapper>
    <PrimaryButton
      onClick={() => handleClickSave()}
      loading={loadingSaveProducts}
      disabled={loadingIframe || loadingSaveAndAddProducts}
    >
      {messages.save}
    </PrimaryButton>
  </ModalButtonsContainer>
)

interface ProductsEditActionsProps {
  loadingIframe: boolean
  loadingSaveProducts: boolean
  loadingSaveAndAddProducts: boolean
  shouldShowReloadProducts: boolean
  handleClickSave: (param?: boolean) => void
  handleCloseModal: () => void
  handleReloadIframe: () => void
}

const ModalButtonsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`

const SecondaryButtonWrapper = styled(SecondaryButton)`
  margin-left: auto;
`

const LoaderWrapper = styled.div`
  display: flex;
  max-height: 32px;
`

const ActionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 3px;
`

const LoaderText = styled(Text)`
  align-self: center;
`

const SmallSquareLoader = styled(SquareDotLoadingIndicator)`
  transform: scale(0.5);
`
